export const ISSUES_PERMS_ACTIONS = Object.freeze({
    EDIT_ISSUE: "EDIT_ISSUE",
    DELETE_ISSUE: "DELETE_ISSUE",
    CREATE_ISSUE: "CREATE_ISSUE",
});
